import { render, staticRenderFns } from "./WorkDynamic.vue?vue&type=template&id=c437d6fa&scoped=true&"
import script from "./WorkDynamic.vue?vue&type=script&lang=js&"
export * from "./WorkDynamic.vue?vue&type=script&lang=js&"
import style0 from "./WorkDynamic.vue?vue&type=style&index=0&id=c437d6fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c437d6fa",
  null
  
)

export default component.exports